<template>
  <div  class="order-detail-container">
    <div class="mod2 flex-col" v-if="payEnterpriseList.length > 0">
      <div class="bd1 flex-col">
        <div class="bd2 flex-row">
          <span class="info2">开票抬头</span>
          <div class="group1 flex-col">
            <router-link :to="{ name: 'invoiceTitleModify', params: {order: order, addressType: 4}}" style="margin-top: 2px">
<!--              <div style="margin-top: 2px" @click=contactCustomerService>-->
                <span class="word4">修改</span>
<!--              </div>-->
            </router-link>
          </div>
        </div>
        <div class="full-split-line" style="margin-top: 21px;margin-left: 15px"></div>
        <div style="height: 60px;margin-left: 15px;"  v-for="(payEnterprise,index) in payEnterpriseList">
          <div class="bd6 flex-col">
            <span class="word3">{{payEnterprise.enterpriseInvoiceTitle}}</span>
          </div>
          <div class="bd5 flex-col" v-if="index < payEnterpriseList.length -1"> <div class="full-split-line"></div></div>
        </div>
<!--        <div class="bd5 flex-col"><div class="group2 flex-col"></div></div>-->
<!--        <div class="bd6 flex-col">-->
<!--          <span class="word3">上海交通大学医学院附属仁济医院</span>-->
<!--        </div>-->
      </div>

    </div>
    <div class="mod3 flex-col">
      <div class="layer2 flex-col">
        <div class="box2 flex-row">
          <span class="word5">发票寄送地址</span>
          <div class="layer3 flex-col" >
            <router-link :to="{ name: 'WeappAddress', params: {order: order, addressType: 4}}" style="margin-top: 2px">
              <span class="info5">修改</span>
            </router-link>
          </div>
        </div>
        <div class="full-split-line" style="margin-top: 21px;margin-left: 15px"></div>
        <div class="block-item">
         <div class="block-address">
                    <i class="icon-font emkt-icon-didian research-font-color" style="font-size: 18px;"></i>
                    <div class="item-detail">
                      <span class="deep-text-color">{{order.invoiceAddress || '无发票寄送地址'}}</span>
                      <span class="light-text-color">{{order.invoiceName}} {{order.invoiceMobile}}</span>
                    </div>
                  </div>
          </div>
<!--        <div class="box4 flex-row">-->
<!--          <i class="icon-font emkt-icon-didian place"></i>-->
<!--          <span class="info3">-->
<!--               {{order.invoiceAddress || '无发票寄送地址'}}-->
<!--              </span>-->
<!--        </div>-->
<!--        <div class="box5 flex-row">-->
<!--          <span class="txt1">{{order.invoiceName}} &nbsp;&nbsp; {{order.invoiceMobile}}</span>-->
<!--        </div>-->
      </div>
    </div>
    <span class="txt2" v-if="canAddPayEnterprise">
          下单成功后，吉凯工作人员会主动联系您为您开具发票。发票未寄出之前，您可以修改发票抬头与寄送地址
        </span>
<!--    <div class="content-block">-->
<!--      <div class="block-item" style="height: 62px;;-->
<!--font-size: 14px;-->
<!--font-family: PingFangSC-Medium, PingFang SC;-->
<!--font-weight: 500;-->
<!--color: #424242;-->
<!--line-height: 20px;">-->
<!--        开票抬头-->
<!--        <router-link :to="{ name: 'invoiceTitleModify', params: {order: order, addressType: 4}}">-->
<!--          <div class="update-address update-address-color">修改</div>-->
<!--        </router-link>-->
<!--      </div>-->
<!--      <div class="full-split-line"></div>-->
<!--      <div class="block-item" v-for="(payEnterprise,index) in payEnterpriseList" style="border-bottom: .5px solid #efeef3;">-->
<!--        <div :class="getMainClass(payEnterprise)" >-->
<!--              <span   @click="openSerchPayEnterprise(index,false)" class="open-popup open-enterprise" data-popup=".popup-invoice-title">-->
<!--                {{getPayExperienceLabel(payEnterprise.enterpriseInvoiceTitle)}}-->
<!--           <br />-->
<!--         <span>-->
<!--            {{payEnterprise.enterpriseInvoiceTaxRegNo}}-->
<!--          </span>-->
<!--                  </span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="order-content-block">-->
<!--      <div class="block-item" style="height: 62px;;-->
<!--font-size: 14px;-->
<!--font-family: PingFangSC-Medium, PingFang SC;-->
<!--font-weight: 500;-->
<!--color: #424242;-->
<!--line-height: 20px;">-->
<!--        发票寄送地址-->
<!--        <router-link :to="{ name: 'WeappAddress', params: {order: order, addressType: 4}}">-->
<!--          <div class="update-address update-address-color">修改</div>-->
<!--        </router-link>-->
<!--      </div>-->
<!--    <div class="full-split-line"></div>-->
<!--    &lt;!&ndash;        发票寄送地址&ndash;&gt;-->
<!--&lt;!&ndash;    <img src="static/img/invoice.png" class="invoice-label">&ndash;&gt;-->
<!--    <div class="block-item" style="height: 81px;">-->
<!--      <div class="block-address">-->
<!--        <i class="icon-font emkt-icon-didian research-font-color" style="font-size: 18px;"></i>-->
<!--        <div class="item-detail">-->
<!--          <span class="deep-text-color">{{order.invoiceAddress || '无发票寄送地址'}}</span>-->
<!--          <span class="light-text-color">{{order.invoiceName}} {{order.invoiceMobile}}</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    </div>-->
  </div>
</template>


<script>
  // import $ from 'jquery'
  import Emkt from '../../emkt'
  import {mapState, mapMutations} from 'vuex'

  export default {
    created () {
      this.fetchData()
    },
    mounted () {
    },
    watch: {
      'invoiceInfo': function (val) {
        var _this = this
        const samePayEnterprise = _this.payEnterpriseListData.find(mer => val.enterpriseNo === mer.enterpriseNo)
        console.log(samePayEnterprise)
        if (samePayEnterprise) {
          _this.$weui.topTips('该开票抬头已经存在！不可重复添加！')
          return
        }
        _this.payEnterpriseListData.splice(this.payEnterpriseIndex, 1, val)
        _this.$weui.confirm('确定要更新订单开票抬头?', {
          title: '提示',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function () { console.log('no') }
          }, {
            label: '确定',
            type: 'primary',
            onClick: function () {
              _this.updatepayEnterprise()
            }
          }]
        })
        console.log(val)
      },
      '.popup-invoice-title': function (val) {
        alert(1111)
      }
    },
    data () {
      return {
        payEnterpriseIndex: null,
        payEnterpriseListData: [],
        showPayEnterprise: true
      }
    },
    components: {
    },
    computed: {
      ...mapState([
        'sessionInfo', 'invoiceInfo', 'chosenOrder'
      ]),
      payEnterpriseList () {
        console.log('this.payEnterpriseListData', this.payEnterpriseListData)
        return this.payEnterpriseListData
      },
      canAddPayEnterprise () {
        return this.chosenOrder.payType !== Emkt.PAY_TYPE_REMAIN_MONEY && this.showPayEnterprise
      },
      order () {
        if (this.$route.params.order) {
          this.UPDATE_CHOSEN_ORDER(this.$route.params.order)
        }
        return this.chosenOrder
      }
    },
    methods: {
      ...mapMutations([
        'UPDATE_CHOSEN_ORDER'
      ]),
      // contactCustomerService () {
      //   this.$weui.alert('请联系客服')
      // },
      getPayExperienceLabel (label) {
        return label
      },
      getMainClass (payEnterprise) {
        return payEnterprise.enterpriseInvoiceTitle ? 'main3' : 'main4'
      },
      getMainStyle (payEnterprise) {
        return payEnterprise.enterpriseInvoiceTitle ? 'float: right;margin-top: 10px' : 'float: right;margin-top: -10px'
      },
      getTextStyle (payEnterprise) {
        return payEnterprise.enterpriseInvoiceTitle ? 'border: none;' : 'border: none; background-color: rgba(239, 238, 243, 1);'
      },
      addPayEnterprise () {
        let payEnterprise = {}
        this.payEnterpriseListData.push(payEnterprise)
        console.log('this.payEnterpriseList', this.payEnterpriseList)
      },
      removePayEnterprise (index) {
        var _this = this
        if (_this.payEnterpriseListData[index].enterpriseInvoiceTitle) {
          if (_this.payEnterpriseListData.length <= 1) {
            _this.$weui.topTips('订单开票抬头不可为空', 2000)
          } else {
            _this.$weui.confirm('确定要删除订单开票抬头?', {
              title: '提示',
              buttons: [{
                label: '取消',
                type: 'default',
                onClick: function () { console.log('no') }
              }, {
                label: '确定',
                type: 'primary',
                onClick: function () {
                  _this.payEnterpriseListData.splice(index, 1)
                  _this.updatepayEnterprise()
                  console.log('this.payEnterpriseList', _this.payEnterpriseList)
                }
              }]
            })
          }
        } else {
          _this.payEnterpriseListData.splice(index, 1)
        }
      },
      openSerchPayEnterprise (index, val) {
        this.payEnterpriseIndex = index
      },
      fetchData () {
        var _this = this
        console.log(this.$route.params.order)
        _this.gcapi('getOrderPayEnterpriseNos', _this.order.id).then(function (response) {
          var map = Emkt.getLocalStorage('EmktFirstLevelEnterpriseNoMap')
          let rlist = response.body.result
          console.log(map)
          if (rlist.length > 0) {
            rlist.forEach(data => {
              let d = map[data]
              if (d !== undefined) {
                let enterprise = {
                  'enterpriseInvoiceTitle': d.enterpriseInvoiceTitle,
                  'enterpriseNo': d.enterpriseNo
                }
                _this.payEnterpriseListData.push(enterprise)
              }
            })
          } else {
            _this.showPayEnterprise = false
          }
        })
      },
      updatepayEnterprise () {
        var self = this
        console.log(self.payEnterpriseList)
        let payEnterpriseNos = []
        self.payEnterpriseList.forEach(payEnterpriseNo => {
          if (payEnterpriseNo.enterpriseNo && payEnterpriseNo.enterpriseNo !== '') {
            payEnterpriseNos.push(payEnterpriseNo.enterpriseNo)
          }
        })
        self.$weui.loading('正在更新订单开票抬头')
        var param = {
          payEnterpriseNoList: payEnterpriseNos,
          rootOrderId: self.order.id
        }
        self.gcapi('updateOnlineOrderPayEnterprise', param).then(function (response) {
          self.$weui.loading().hide()
          self.$weui.toast('更新成功！', 2500)
        })
      }
    }
  }

</script>
<style scoped>


  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox:after {
    background: no-repeat center;
    background-image: url('/static/img/tick.png');
    background-size: .6REM .45rem;
  }

  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
  }


  .order-detail-container {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    position: relative;
    /*background-color: #FAFAFA;*/
    padding: 10px;
    padding-bottom: 0;
    background: #FAFAFA;
  }
  .mod2 {
    z-index: 57;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    align-self: center;
    justify-content: flex-end;
    padding-bottom: 10px;
    position: relative;
  }

  .bd1 {
    z-index: auto;
  }

  .bd2 {
    z-index: auto;
    margin-left: 15px;
    margin-top: 21px;
    height: 23px;
    justify-content: space-between;
  }

  .info2 {
    z-index: 70;
    width: 56px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Medium;
    line-height: 20px;
    text-align: left;
    margin-top: 3px;
  }

  .group1 {
    z-index: 66;
    width: 42px;
    height: 23px;
    margin-right: 15px;
    border-radius: 11.5px 11.5px 11.5px 11.5px;
    border: 1px solid rgba(88, 120, 250, 1);
  }

  .bd5 {
    z-index: 58;
    height: 1px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng27ff867801955b5fee8c83134dba8cfaa6c4c530d149e5d3830937a20c360f50)
    100% no-repeat;
    align-self: center;
    margin-top: 10px;
  }

  .group2 {
    z-index: 68;
    width: 340px;
    height: 1px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng27ff867801955b5fee8c83134dba8cfaa6c4c530d149e5d3830937a20c360f50)
    100% no-repeat;
  }

  .bd6 {
    z-index: 63;
    height: 40px;
    border-radius: 5px;
    background-color: rgba(250, 250, 250, 1);
    align-self: flex-start;
    margin-top: 10px;
    margin-right: 15px;
    justify-content: center;
    align-items: flex-start;
    padding-left: 10px;
  }

  .word3 {
    z-index: 64;
    width: 290px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(151, 151, 151, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
  }

  .word4 {
    display: block;
    overflow-wrap: break-word;
    color: rgba(88, 120, 250, 1);
    font-size: 12px;
    font-family: PingFangSC-Regular;
    line-height: 17px;
    text-align: center;
  }
  .flex-col {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
  }
  .txt2 {
    z-index: 2;
    margin-left: 15px;
    margin-right: 15px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(146, 146, 146, 1);
    font-size: 12px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: justify;
    align-self: center;
    margin-top: 10px;
  }
  .mod3 {
    z-index: 3;
    height: 142px;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    align-self: center;
    margin-top: 10px;
    justify-content: flex-end;
    padding-bottom: 10px;
    position: relative;
  }

  .layer2 {
    z-index: auto;
    height: 103px;
  }

  .box2 {
    z-index: auto;
    height: 23px;
    margin-left: 15px;
    justify-content: space-between;
  }

  .word5 {
    z-index: 4;
    width: 84px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Medium;
    line-height: 20px;
    text-align: left;
    margin-top: 2px;
  }

  .layer3 {
    z-index: 53;
    width: 42px;
    height: 23px;
    margin-right: 15px;
    border-radius: 11.5px 11.5px 11.5px 11.5px;
    border: 1px solid rgba(88, 120, 250, 1);
  }

  .box3 {
    z-index: 13;
    width: 339px;
    height: 1px;
    border-top: .5px solid #efeef3;
    align-self: center;
    margin-top: 19px;
  }

  .box4 {
    z-index: auto;
    height: 40px;
    margin-top: 9px;
  }

  .icon4 {
    z-index: 6;
    width: 12px;
    height: 17px;
    margin-top: 22px;
  }

  .info3 {
    z-index: 10;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Medium;
    line-height: 20px;
    text-align: left;
    margin-left: 10px;
  }

  .box5 {
    z-index: auto;
    height: 17px;
    justify-content: space-between;
    margin: 4px 0 0 22px;
    margin-top: -5px;
  }

  .txt1 {
    z-index: 11;
    display: block;
    overflow-wrap: break-word;
    color: rgba(146, 146, 146, 1);
    font-size: 12px;
    font-family: PingFangSC-Regular;
    line-height: 17px;
    text-align: left;
  }

  .info4 {
    z-index: 12;
    width: 74px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(146, 146, 146, 1);
    font-size: 12px;
    font-family: PingFangSC-Regular;
    line-height: 17px;
    text-align: left;
  }

  .info5 {
    z-index: 54;
    display: block;
    overflow-wrap: break-word;
    color: rgba(88, 120, 250, 1);
    font-size: 12px;
    font-family: PingFangSC-Regular;
    line-height: 17px;
    text-align: center;
  }
  .place {
    display: flex;
    align-items: center;
    margin-top: 32px;
    color: #5878FA;
    width: 12px;
    height: 17px;
  }
  .block-item {
    /*height: 35px;*/
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    flex-shrink: 0;
    padding-top: 15px;
  }
  .block-address {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 90%;
    margin-left: 15px;
  }
  .item-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
  }
  .deep-text-color {
    color: #424242;
    font-size: 12px;
    font-weight: bold;
  }
  .deep-color {
    color: #424242;
    font-size: 12px;
  }
  .tiny-font {
    font-size: 12px;
    transform: scale(0.8);
    transform-origin: left center;
  }
  .light-text-color {
    color: #929292;
    font-size: 12px;
  }

  .full-split-line {
    border-top: .5px solid #efeef3;
    height: 1px;
  }
</style>



// WEBPACK FOOTER //
// updateInvoiceTitle.vue?51bfb647